import { StateService } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IAggregatedReactionsMap } from "@gtmhub/comments";
import dayjs from "@gtmhub/dayjs";
import { IIndicator } from "@gtmhub/error-handling";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { IMetricSnapshot, Metric } from "../../models/metric.models";

@Component({
  selector: "metric-snapshots",
  templateUrl: "metric-snapshots.component.html",
  styleUrls: ["metric-snapshots.component.less"],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [DestroyService],
})
export class MetricSnapshotsComponent implements OnChanges {
  @Input()
  public indicators: {
    loading?: IIndicator;
    loadingUpdate?: IIndicator;
    refreshingMetric?: IIndicator;
    doNotDisplaySnapshots?: IIndicator;
  };

  @Input()
  public metric: Metric;

  @Input()
  public sourceMetric: Metric;

  @Input()
  public reactions: IAggregatedReactionsMap;

  constructor(private stateService: StateService) {}

  public limitSnapshotsTo = 50;
  public limitSnapshotsStep = 50;
  public history: IMetricSnapshot[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.metric) {
      this.history = this.metric.metricHistory?.sort((a, b) => this.getSnapshotSortField(b) - this.getSnapshotSortField(a));
    }
  }

  public trackById(index: number, field: IMetricSnapshot): string {
    return field.id;
  }

  public showComments = (snapshotItem: IMetricSnapshot): void => {
    this.stateService.go(".threadNew", { targetId: snapshotItem.id, targetType: "checkin" });
  };

  private getSnapshotSortField = (snapshot: IMetricSnapshot): number => {
    return dayjs(snapshot.updatedAt).valueOf();
  };
}
